import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esBipolar } from "@/pages/es/esConditionData1";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute("/es/bipolar-disorder-coral-springs-fl")({
  head: () => buildEsConditionHead(esBipolar),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esBipolar} />;
}
